import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { apiHelper } from "../../lib/ApiHelper";
import { AgGridReact } from "@ag-grid-community/react";
import "../MainBox.css";
import ReprintDelete from "../reprintDeleteWarningPopUp";
import "react-datepicker/dist/react-datepicker.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReprintDK from "./ReprintDK";
import PRHLoader from "../../lib/PRHLoader";

const formatPercentage = (value) => {
    try {
        if (!value || isNaN(value.toString())) { return ''; }
        return `${(Number(value) * 100).toFixed(2).toString()}%`;
    } catch {
        return '';
    }
}
const formatDate = (value, langFormatStyle = 'es-CL') => {
    try {
        return value ? (new Date(value)).toLocaleDateString(langFormatStyle) : '';
    } catch {
        return '';
    }
}
const formatNumber = (value) => {
    if (!value || isNaN(value.toString())) { return ''; }
    var sansDec = Number(value).toFixed(0);
    var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return formatted;
}

export default function ForecastDK(props) {
    const [formData, setFormData] = useState({ isbn: null, threeMonth: null, sixMonth: null, twelveMonth: null, targetWeeks: null, dateUpdated: null, weeksOnHand: null, recommendedReprintQty: null });
    const [reprintActive, setreprintActive] = useState(false);
    const [reprintActiveCVR, setreprintActiveCVR] = useState(false);
    const [isLongLead, setIsLongLead] = useState(null);
    const [isForeLoading, setIsForeLoading] = useState(false);
    

    const gridOptions = {
        defaultColDef: {
            resizable: false,
            sortable: true,
        },
        width: '100%',
        animateRows: true,
        accentedSort: true,
        suppressDragLeaveHidesColumns: true, // ✅ stops column from being dragged away (out of the grid)
        suppressColumnMoveAnimation: false,  // optional: shows animation when interchanging
        suppressRowClickSelection: true
    };
    const columnDefs = [
        {
            headerName: "BL OTIS Grp", field: "backlistGroup", headerClass: "HeaderClassSource",
            cellClass: "CellClassSource cell-text-left", width: 120
        },
        {
            headerName: "Current Est", field: "currentEst", headerClass: "HeaderClassSource NumberHeaderClassSource",
            cellClass: "CellClassSource cell-text-right", width: 70,
            valueFormatter: params => formatNumber(params.value)
        },
        {
            headerName: "Latest Edit Date", field: "latestEstDate", headerClass: "HeaderClassSource header-text-right",
            cellClass: "CellClassSource cell-text-right", width: 100,
            cellRenderer: params => formatDate(params.value)
        }
    ];

    const fetchData = async (id) => {
        try {

            if (id) {
                setIsForeLoading(true);
                const data = await apiHelper.inventoryPostCall("getForecast", { value: id });
                if (data.foreCastData != undefined && data.foreCastData != null) {
                    setFormData(data.foreCastData);

                } else {
                    setFormDataNull();

                }

            }
        } catch (error) {
            console.error("Error at fetch forecast " + error);
        } finally {
            setIsForeLoading(false);
        }
    }

    const setFormDataNull = () => {
        setFormData({ isbn: null, threeMonth: null, sixMonth: null, twelveMonth: null, targetWeeks: null, dateUpdated: null, weeksOnHand: null, recommendedReprintQty: null })
    }

    

    const onCloseCVR = () => {
        setreprintActiveCVR(prev => !prev);
    }

    const onClose = () => {
        setreprintActive(prev => !prev);
    }

    const deleteReprint = async (cvr) => {
        try {
            const res = await apiHelper.inventoryPostCall("deleteRerpint", { ISBN: props.ISBNId, cvrjckt: cvr });
            if (res && !cvr) {
                const res2 = await apiHelper.inventoryPostCall("deleteRerpint", { ISBN: props.ISBNId, cvrjckt: !cvr });
                
            }
            if (res) {
                fetchData(props.ISBNId);
            }
            if (cvr) {
                setreprintActiveCVR(prev => !prev);
            }
            else onClose();
        } catch (e) {
            console.error(e);
        }
    }

    const handleCheckBoxChange = async (e) => {
        try {
            setIsLongLead(prev => !prev);
            const res = await apiHelper.inventoryPostCall("SetLongLeadISBN", { ISBN: props.ISBNId, isLongLead: e.target.checked });
            if (!res) LoadLongLead();
        } catch (error) {
            LoadLongLead();
            console.error(error);
        }
    }
    const LoadLongLead = async () => {
        try {
            const res = await apiHelper.inventoryPostCall("CheckLongLeadISBN", { value: props.ISBNId });
            setIsLongLead(res);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if (props.ISBNId != null && props.ISBNId != "") {
            fetchData(props.ISBNId);
            LoadLongLead();
        }
    }, [props.metaData]);


  

    function formatDateForInput(dateString) {
        if (dateString == null || dateString == "")
            return null;
        const date = new Date(dateString);
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0');
        let day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }



    return (<>
        <div className="accordion-content custom Forecast">
            <Form noValidate="noValidate" >
                {isForeLoading && <PRHLoader className="smal" />}
                <Row>

                    <Col md={props.metaData?.backListOtisEstimates && props.metaData?.backListOtisEstimates?.length > 0 ? 8 : 12}>

                        <Row className={`${isForeLoading ? "mt-0" : "mt-3"}`}>
                        
                            <Col md={12} className="fit-content">
                                <p className="ml-0 mb-0 mb-2">Sales Performance</p>
                            </Col>
                        </Row>
                        <Row className="">
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >3 Month</Form.Label>
                                    <input className="custom-input left-p-input right-align width80" name="threeMonth" value={formData.threeMonth ? formData.threeMonth.toLocaleString() : ""} placeholder="" disabled />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >6 Month</Form.Label>
                                    <input id="formGroupID" className="custom-input left-p-input right-align  width80" placeholder="" name="sixMonth " value={formData.sixMonth ? formData.sixMonth.toLocaleString() : ""} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >12 Month</Form.Label>
                                    <input id="formGroupID" className="custom-input left-p-input right-align width80" placeholder="" name="twelveMonth " value={formData.twelveMonth ? formData.twelveMonth.toLocaleString() : ""} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group>
                                    <Form.Label >Weeks OnHand</Form.Label>
                                    <input id="formGroupID" className="custom-input left-p-input right-align " placeholder="" name="weeksOnHand " value={formData.weeksOnHand ? formData.weeksOnHand.toLocaleString() : ""} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label>Rec Reprint Qty</Form.Label>
                                    <input id="formGroupID" className="custom-input left-p-input right-align" placeholder="" name="recommendedReprintQty " value={formData.recommendedReprintQty ? formData.recommendedReprintQty.toLocaleString() : ""} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Target Weeks</Form.Label>
                                    <input id="formGroupID" className="custom-input left-p-input right-align" placeholder="" name="targetWeeks " value={formData.targetWeeks ? formData.targetWeeks.toLocaleString() : ""} disabled />
                                </Form.Group>
                            </Col>
                            <Col md={1} className="fit-content">
                                <Form.Group >
                                    <Form.Label >Date Updated</Form.Label>
                                    <input id="formGroupID" className="custom-input left-p-input width100" placeholder="" name="dateUpdated " value={formatDateForInput(formData.dateUpdated) || ""} disabled />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={2} className="fit-content">
                                <Form.Group>
                                    <Form.Label>3 Month ROM</Form.Label>
                                    <input className="custom-input left-p-input right-align width80" name="threeMonthRom" value={formatNumber(props?.metaData?.rom3Month)} placeholder="" disabled />
                                </Form.Group>
                            </Col>
                            <Col md={2} className="fit-content">
                                <Form.Group>
                                    <Form.Label>6 Month ROM</Form.Label>
                                    <input className="custom-input left-p-input right-align width80" name="sixMonthRom" value={formatNumber(props?.metaData?.rom6Month)} placeholder="" disabled />
                                </Form.Group>
                            </Col>
                            <Col md={2} className="fit-content">
                                <Form.Group >
                                    <Form.Label>12 Month ROM</Form.Label>
                                    <input className="custom-input left-p-input right-align width80" name="twelveMonthRom" value={formatNumber(props?.metaData?.rom12Month)} placeholder="" disabled />
                                </Form.Group>
                            </Col>
                            <Col md={2} className="fit-content">
                                <Form.Group>
                                    <Form.Label>YoY % Change</Form.Label>
                                    <input className="custom-input left-p-input right-align width80" name="yoyChange" value={formatPercentage(props?.metaData?.yoyChange)} placeholder="" disabled />
                                </Form.Group>
                            </Col>
                            <Col md={1} title="+5weeks review buffer, for Overseas titles only">
                                <Form.Group >
                                    <Form.Label>Long Lead Time</Form.Label><br />
                                    {props.isEditable 
                                        ?
                                        <input type="checkbox" className="checkbox ml-4" name="isLongLead" value={isLongLead ?? false} onChange={handleCheckBoxChange} checked={isLongLead ?? false} />
                                        :
                                        <input type="checkbox" className="disabledcheck checkbox ml-4" name="isLongLead" value={isLongLead ?? false} defaultChecked={isLongLead ?? false} disabled={!isLongLead} />
                                    }
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                    {props.metaData?.backListOtisEstimates && props.metaData?.backListOtisEstimates?.length > 0 &&
                        <Col md={4}>
                            <AgGridReact
                                rowData={props.metaData?.backListOtisEstimates}
                                columnDefs={columnDefs}
                                domLayout="autoHeight"
                                gridOptions={gridOptions}
                            />
                        </Col>
                    }
                </Row>
          

            </Form>
            <ReprintDK ISBN={props.ISBNId} UPN={props.upn} isEditable={props?.isEditable} metaData={props?.metaData}></ReprintDK>
            {reprintActive && <ReprintDelete onClose={onClose} reprintActive={reprintActive} deleteReprint={() => deleteReprint(false)}  ></ReprintDelete>}
            {reprintActiveCVR && <ReprintDelete onClose={onCloseCVR} reprintActive={reprintActiveCVR} deleteReprint={() => deleteReprint(true)}  ></ReprintDelete>}
           
        </div>


    </>)
}